// extracted by mini-css-extract-plugin
export default {"container":"XN-z","error":"YN-z","disabled":"ZN-z","submit":"_N-z","option":"aO-z","success":"bO-z","failure":"cO-z"};